import css from 'styled-jsx/css'
import { colors, sizes } from '../../theme'

export default css`
  .hidden {
    display: none;
  }

  .button {
    display: block;
    background-color: transparent;
    color: ${colors.pureWhite};
    text-decoration: underline;
    cursor: pointer;
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    /* display: none; */
  }
`
